import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class RecruitTracking extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getTeamPerformance = this.getTeamPerformance.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentDidMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 1)

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getTeamPerformance() {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/demonstrator/GetRecruitTracking?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
            let demRecs = [];
            let rec;
            response.data.map((dem) => {
                rec = {
                    zoneName: dem.zoneName,
                    unitCode: dem.unitCode,
                    unitName: dem.unitName,
                    recByCode: dem.recByCode,
                    recBySFName: dem.recBySFName,
                    RecruiterStatus: dem.recruiterStatus,
                    RecruitedByCell: dem.recruitedByCell,
                    sfCurrentCode: dem.sfCurrentCode,
                    sfName: dem.sfName,
                    registerdCell: dem.registerdCell,
                    status: dem.status,
                    startWeekId: dem.startWeekId,
                    Channel: dem.channel,
                    StartSegmentId: dem.startSegmentId,
                    DateJoined: dem.dateJoined,
                    OnlineRecruit: dem.onlineRecruit,
                    Kit: dem.kit,
                    KitSaleDate: dem.kitSaleDate,
                    JourneyType: dem.journeyType,
                    AttendedTraining: dem.attendedTraining,
                    TrainingWeek: dem.trainingWeek,
                    DateOfContact: dem.dateOfContact,
                    ContactStatus: dem.contactStatus,
                    month0: this.formatter.formatCurrency(dem.month0),
                    rM1: this.formatter.formatCurrency(dem.rM1),
                    month1: this.formatter.formatCurrency(dem.month1),
                    rM2: this.formatter.formatCurrency(dem.rM2),
                    month2: this.formatter.formatCurrency(dem.month2),
                    rM3: this.formatter.formatCurrency(dem.rM3),
                    month3: this.formatter.formatCurrency(dem.month3),
                    rM4: this.formatter.formatCurrency(dem.rM4),
                    month4: this.formatter.formatCurrency(dem.month4),
                    rM5: this.formatter.formatCurrency(dem.rM5),
                    month5: this.formatter.formatCurrency(dem.month5),
                    rM6: this.formatter.formatCurrency(dem.rM6),
                    month6: this.formatter.formatCurrency(dem.month6),
                    rM7: this.formatter.formatCurrency(dem.rM7),
                    month7: this.formatter.formatCurrency(dem.month7),
                    rM8: this.formatter.formatCurrency(dem.rM8),
                    month8: this.formatter.formatCurrency(dem.month8),
                    rM9: this.formatter.formatCurrency(dem.rM9),
                    month9: this.formatter.formatCurrency(dem.month9),
                    rM10: this.formatter.formatCurrency(dem.rM10),
                    month10: this.formatter.formatCurrency(dem.month10),
                    rM11: this.formatter.formatCurrency(dem.rM11),
                    month11: this.formatter.formatCurrency(dem.month11),
                    rM12: this.formatter.formatCurrency(dem.rM12)
                }
                demRecs.push(rec);
            });
            let tableData = {
                columns: [{
                    label: 'DS Name',
                    field: 'zoneName'
                }, {
                    label: 'Unit Code',
                    field: 'unitCode'
                }, {
                    label: 'Unit Name',
                    field: 'unitName'
                }, {
                    label: 'Recruited By Code',
                    field: 'recByCode'
                }, {
                    label: 'Recruited By Name',
                    field: 'recBySFName'
                }, {
                    label: 'Recruited By Status',
                    field: 'RecruiterStatus'
                }, {
                    label: 'Recruited By Cell',
                    field: 'RecruitedByCell'
                }, {
                    label: 'New Recruit Code',
                    field: 'sfCurrentCode'
                }, {
                    label: 'New Recruit Name',
                    field: 'sfName'
                }, {
                    label: 'Registered Cell',
                    field: 'registerdCell'
                }, {
                    label: 'Status',
                    field: 'status'
                }, {
                    label: 'Start Week',
                    field: 'startWeekId'
                }, {
                    label: 'Channel',
                    field: 'Channel'
                }, {
                    label: 'Start Segment',
                    field: 'StartSegmentId'
                }, {
                    label: 'Date Joined',
                    field: 'DateJoined'
                }, {

                    label: 'Online Recruit',
                    field: 'OnlineRecruit'
                },
                {
                    label: 'Kit',
                    field: 'Kit'
                },
                {
                    label: 'Kit Sale Date',
                    field: 'KitSaleDate'
                },
                {
                    label: 'Journey Type',
                    field: 'JourneyType'
                },

                {
                    label: 'Attended Training',
                    field: 'AttendedTraining'
                },
                {
                    label: 'Week Training Attended',
                    field: 'TrainingWeek'
                },
                {
                    label: 'Date of Contact',
                    field: 'DateOfContact'
                },
                {
                    label: 'Contact Status',
                    field: 'ContactStatus'
                },

                {
                    label: 'Segment 1 new recruit Sales',
                    field: 'month0'
                },
                {
                    label: 'Segment 1 Recruiter Sales',
                    field: 'rM1'
                },
                {
                    label: 'Segment 2 new recruit Sales',
                    field: 'month1'
                },
                {
                    label: 'Segment 2 Recruiter Sales',
                    field: 'rM2'
                },
                {
                    label: 'Segment 3 new recruit Sales',
                    field: 'month2'
                },
                {
                    label: 'Segment 3 Recruiter Sales',
                    field: 'rM3'
                },
                {
                    label: 'Segment 4 new recruit Sales',
                    field: 'month3'
                },
                {
                    label: 'Segment 4 Recruiter Sales',
                    field: 'rM4'
                },
                {
                    label: 'Segment 5 new recruit Sales',
                    field: 'month4'
                },
                {
                    label: 'Segment 5 Recruiter Sales',
                    field: 'rM5'
                },
                {
                    label: 'Segment 6 new recruit Sales',
                    field: 'month5'
                },
                {
                    label: 'Segment 6 Recruiter Sales',
                    field: 'rM6'
                },
                {
                    label: 'Segment 7 new recruit Sales',
                    field: 'month6'
                },
                {
                    label: 'Segment 7 Recruiter Sales',
                    field: 'rM7'
                },
                {
                    label: 'Segment 8 new recruit Sales',
                    field: 'month7'
                },
                {
                    label: 'Segment 8 Recruiter Sales',
                    field: 'rM8'
                },
                {
                    label: 'Segment 9 new recruit Sales',
                    field: 'month8'
                },
                {
                    label: 'Segment 9 Recruiter Sales',
                    field: 'rM9'
                },
                {
                    label: 'Segment 10 new recruit Sales',
                    field: 'month9'
                },
                {
                    label: 'Segment 10 Recruiter Sales',
                    field: 'rM10'
                },
                {
                    label: 'Segment 11 new recruit Sales',
                    field: 'month10'
                },
                {
                    label: 'Segment 11 Recruiter Sales',
                    field: 'rM11'
                },
                {
                    label: 'Segment 12 new recruit Sales',
                    field: 'month11'
                },
                {
                    label: 'Segment 12 Recruiter Sales',
                    field: 'rM12'
                }],
                rows: demRecs
            }
            this.setState({
                teamData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {

        return (
            <div>
                <Header headerText='Recruit Tracking Report'
                    subHeaderText="(Click Go to load detailed report for selected weeks)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol>
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="From Week..."
                                                options={this.state.fromWeekData}
                                                selected="Filter"
                                                getValue={this.handleFromSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="To Week..."
                                                options={this.state.toWeekData}
                                                selected="Filter"
                                                getValue={this.handleToSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getTeamPerformance}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>

                            {/*<MDBCol md="6">*/}
                            {/*    <MDBContainer>*/}
                            {/*        <DashboardLineGraph chartName="Team Sales Performance" graphData={this.state.teamGraphData} />*/}
                            {/*    </MDBContainer>*/}
                            {/*</MDBCol>*/}
                        </MDBRow>

                        <br />

                        <div hidden={this.state.tableHidden}>
                            <hr />
                            <MDBContainer>
                                <MDBRow>
                                    <span style={{ fontWeight: "bold" }}>Detailed Recruit Results<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</span>
                                </MDBRow>

                            </MDBContainer>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                hover
                                data={this.state.teamData}
                                paging={false}
                                autoWidth
                            />;

                        </div>
                    </MDBCardBody>
                </MDBCard>
            </div>
        );
    }


}
